import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  Input
} from '@angular/core';
import { environment } from 'environments/environment';
import { CpmService } from '../../service/cpm.service';
import { ActivatedRoute } from '@angular/router';
import { FinancialHeaderComponent } from '../financial-header/financial-header.component';
import { FinancialTableComponent } from '../financial-table/financial-table.component';
import { StoreService } from '../../service/store.service';
import { ExportExcelService } from 'app/service/export-excel.service';

@Component({
  selector: 'app-financial',
  templateUrl: './financial.component.html',
  styleUrls: ['./financial.component.scss']
})
export class FinancialComponent implements OnInit, AfterViewInit {
  @Input()
  isFullFactSheet;
  roundOfFreefloat;
  symbol;
  print = false;
  pdf = false;
  getPrint;
  securityFinancialStatisticBySeucritySymbol: Object;
  printPage = false;
  displayComponent = false;
  consolidatedRemark: String =
    'กรณีบริษัทไม่มีงบ Consolidated จะแสดงเป็นงบ Company แทน';
    noticeRemark: String =
    'Financial notice';

  @ViewChild('financialHeader')
  financialHeader: FinancialHeaderComponent;
  @ViewChild('financialTable')
  financialTable: FinancialTableComponent;
  constructor(
    private cpmService: CpmService,
    private activatedRoute: ActivatedRoute,
    private store: StoreService,
    private excelService: ExportExcelService
  ) {}

  ngOnInit() {
    const { symbol } = this.activatedRoute.snapshot.params;
    const { pdf, print } = this.activatedRoute.snapshot.data;
    this.getPrint = print;
    pdf === undefined ? (this.pdf = false) : (this.pdf = pdf);
    print === undefined ? (this.print = false) : (this.print = print);
    if (symbol) {
      this.cpmService.getSecurityProfileNew(symbol);
    }
    if (this.print || this.pdf) {
      this.printPage = true;
    } else {
      this.printPage = false;
    }
    if (symbol !== undefined) {
      this.symbol = symbol;
      this.store.setSearchInputBehavior(this.symbol);
      this.initial(this.symbol);
    } else {
      this.store.getSecurityProfileNewResultObservable().subscribe(response => {
        if (!response) {
          return;
        }
        this.symbol = response['securitySymbol'];
        this.financialTable.checkIFF = response['infrastructureFundFlag'];
        this.financialTable.checkSector = response['sectorNo'];
        this.initial(this.symbol);
      });
    }
  }

  exportFunctions() {
    const arrayOfFunctions: Map<String, Function> = new Map<String, Function>();
    arrayOfFunctions.set(
      'email',
      this.exportEmail(this.symbol, this.cpmService)
    );
    arrayOfFunctions.set('print', this.exportPrint(this.symbol));
    arrayOfFunctions.set('pdf', this.exportPdf(this.symbol));
    arrayOfFunctions.set(
      'excel',
      this.exportExcel(this.excelService, this.financialTable)
    );
    return arrayOfFunctions;
  }

  exportPrint = function(symbol) {
    return function financePrint() {
      const endcodeSymbol = encodeURIComponent(symbol);
      window.open(
        `/#/financial/${endcodeSymbol}`,
        '_blank',
        'width=1200px,height=1024px'
      );
    };
  };

  exportPdf = function(symbol) {
    const service = this.cpmService;
    return function financePdf() {
      const endcodeSymbol = encodeURIComponent(symbol);
      service.downloadFile(
        `${environment.cpmBaseUrl}/pdf/financial?symbol=${endcodeSymbol}`
      );
    };
  };

  exportEmail = function(symbol, service) {
    return function financeMail() {
      const endcodeSymbol = encodeURIComponent(symbol);
      service.saveFinancialHilightPdfFile(endcodeSymbol).then(filename => {
        const subject = 'Financial';
        const downloadUrl = encodeURIComponent(
          `${environment.cpmBaseUrl}/download?type=report&filename=${filename}`
        );
        window.location.href = `mailto:?subject=${subject}&body=${downloadUrl}`;
      });
    };
  };

  exportExcel = function(excelService, finance) {
    return function financeExcel() {
      excelService.exportExcelFinancialSecurityLevel(
        finance.ws_data_toExcel,
        'Financial'
      );
    };
  };

  async initial(securitySymbol: string) {
    this.securityFinancialStatisticBySeucritySymbol = undefined;
    await this.cpmService
      .getSecurityFinancialStatisticBySecuritySymbol(securitySymbol)
      .then(response => {
        this.securityFinancialStatisticBySeucritySymbol = response[0];
        this.displayComponent = true;
      });

    if (this.securityFinancialStatisticBySeucritySymbol) {
      this.financialHeader.period = this.getPeriod();
      this.getAdjustFreefloat();
    } else {
      this.financialHeader.period = 'No data';
    }
  }

  async getAdjustFreefloat() {
    this.roundOfFreefloat = this.securityFinancialStatisticBySeucritySymbol[
      'header'
    ].length + 1;

    let adjustFreefloatFullfill: Array<Object> = new Array<Object>(
      this.roundOfFreefloat
    );

    await this.cpmService
      .getAdjustedFreefloatByRoundAndSecuritySymbol(
        this.roundOfFreefloat,
        this.symbol
      )
      .then(response => {
        adjustFreefloatFullfill = response;
      });

    const adjustFreefloatDataset: Object = {
      type: 'Adjusted free float',
      changeType: 'Change from year earlier (unit)',
      data: new Array()
    };

    if (!adjustFreefloatFullfill) {
      return;
    }

    adjustFreefloatDataset['data'].push(
      this.prepareAdjustFreefloatHeader(adjustFreefloatFullfill)
    );

    adjustFreefloatDataset['data'].push(
      this.prepareAdjustFreefloatData(adjustFreefloatFullfill)
    );

    this.securityFinancialStatisticBySeucritySymbol['data'].push(
      adjustFreefloatDataset
    );
    this.financialTable.data = this.securityFinancialStatisticBySeucritySymbol;
  }

  prepareAdjustFreefloatHeader(data) {
    let finYearTemp;
    if (!data.adjustedFreeFloat) finYearTemp = new Array(this.roundOfFreefloat-1);
    else {
      finYearTemp = data.adjustedFreeFloat.map(x => x.asOfDate).reverse();
      if (finYearTemp.length === this.roundOfFreefloat) finYearTemp.shift();
      else {
        for (let i = finYearTemp.length; i < this.roundOfFreefloat - 1; i++) {
          finYearTemp.unshift(null);
        }
      }
    }
    return new Object({
      type: 'Adjusted free float as of',
      unit: 'Date',
      notice: null,
      noticeLevel: null,
      finYear: finYearTemp,
      finYOY: new Array(finYearTemp.length)
    });
  }

  prepareAdjustFreefloatData(data) {
    let freeFloatList;
    let finYOY;
    if (!data.adjustedFreeFloat) {
      freeFloatList = new Array(this.roundOfFreefloat-1);
      finYOY = new Array(freeFloatList.length);
    }
    else {
      freeFloatList = data.adjustedFreeFloat.map(x => x.freefloat).reverse();
      for (let i = freeFloatList.length; i < this.roundOfFreefloat; i++) {
        freeFloatList.unshift(null);
      }
      finYOY = new Array(data.adjustedFreeFloat.length);
      for (let i = 1; i < freeFloatList.length; i++) {
        finYOY[i] = freeFloatList[i] - freeFloatList[i-1];
      }
      finYOY.shift();
      freeFloatList.shift();
    }
    return new Object({
      type: 'Adjusted free float',
      unit: '%',
      notice: data.notice,
      noticeLevel: data.noticeLevel,
      finYear: freeFloatList,
      finYOY: finYOY
    });
  }

  ngAfterViewInit() {
    if (this.getPrint) {
      window.setTimeout('window.print()', 3000);
    }
  }

  getPeriod() {
    const headerArray = this.securityFinancialStatisticBySeucritySymbol[
      'header'
    ] as Array<Object>;
    const lowerBound = headerArray[0];
    const upperBound = headerArray[headerArray.length - 1];
    return lowerBound + '-' + upperBound + ' (3 years + YTD)';
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/financial/financial.component.ts